import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { scrollTo } from "@/lib/lenis";
import { CATEGORIES } from "@/lib/site";

export default function Categories() {
  return (
    <section id="opportunities" className="py-28 lg:py-36 bg-royal-900/40 border-y border-gold/10" data-testid="categories-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading
          eyebrow="Participation Categories"
          title={<>Find Your <span className="gold-text">Stage</span></>}
          sub="Ten paths into the spotlight — each one crafted to celebrate a different kind of talent."
          testId="categories-heading"
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="categories-grid">
          {CATEGORIES.map((c, i) => (
            <Reveal key={c.name} delay={0.05 * (i % 3)}>
              <article
                className="group relative h-96 overflow-hidden rounded-md border border-gold/15 cursor-pointer"
                onClick={() => scrollTo("#register")}
                data-testid={`category-card-${i}`}
              >
                <img
                  src={c.img}
                  alt={`${c.name} category at HA Treasure House`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-royal-950 via-royal-950/30 to-royal-950/10 transition-opacity duration-500" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <h3 className="font-display text-2xl text-cream group-hover:text-gold-light transition-colors duration-300">{c.name}</h3>
                  <p className="mt-2 text-sm text-cream/75 leading-snug">{c.desc}</p>
                  <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500">
                    <div className="overflow-hidden">
                      <p className="pt-3 text-xs text-gold/90 tracking-wide">{c.eligibility}</p>
                      <p className="text-xs text-muted">{c.benefits}</p>
                    </div>
                  </div>
                  <span className="mt-4 inline-flex items-center gap-2 text-xs font-semibold tracking-widest text-fuchsia opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    APPLY NOW <ArrowRight size={14} />
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-14 text-center">
          <button
            onClick={() => scrollTo("#register")}
            className="rounded-full bg-gold text-royal-950 px-9 py-4 text-sm font-semibold tracking-widest transition-all duration-300 hover:bg-gold-light hover:shadow-[0_0_35px_rgba(212,175,55,0.5)]"
            data-testid="categories-view-cta"
          >
            VIEW PARTICIPATION OPTIONS
          </button>
        </Reveal>
      </div>
    </section>
  );
}
